const WEBP_QUALITY = 0.86;
const MAX_IMAGE_DIMENSION = 1600;

const loadImageElement = file =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Unable to load the selected image.'));
    };

    image.src = objectUrl;
  });

const getScaledDimensions = ({ width, height }) => {
  const longestSide = Math.max(width, height);

  if (!longestSide || longestSide <= MAX_IMAGE_DIMENSION) {
    return { width, height };
  }

  const scale = MAX_IMAGE_DIMENSION / longestSide;

  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
};

const canvasToBlob = canvas =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (blob) {
          resolve(blob);
          return;
        }

        reject(new Error('Unable to convert the image to WebP.'));
      },
      'image/webp',
      WEBP_QUALITY
    );
  });

export const convertImageFileToWebP = async file => {
  const image = await loadImageElement(file);
  const { width, height } = getScaledDimensions(image);
  const canvas = document.createElement('canvas');

  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Unable to prepare the image for upload.');
  }

  context.drawImage(image, 0, 0, width, height);

  const webpBlob = await canvasToBlob(canvas);
  const originalName = file.name.replace(/\.[^.]+$/, '') || 'product-image';

  return new File([webpBlob], `${originalName}.webp`, {
    type: 'image/webp',
    lastModified: Date.now(),
  });
};

export const uploadFileToSignedUrl = async (uploadUrl, file) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error('Unable to upload the image right now.');
  }
};
